export default "__VITE_ASSET__BsLkiM63__"